import { useContext } from 'react';
import { InnovationsContext } from '../components/context/innovations-context';
export const useInnovations = () => useContext(InnovationsContext);